// SPA entry point. Mounts the root `App.svelte` component into the
// `#root` div, replacing the boot-loader placeholder.
//
// Kept tiny on purpose. Everything router/auth/store/data-layer
// related lives in src/router/, src/state/, src/api/ etc. (added in
// later phases of the migration). main.ts only:
//
//   1. imports the global stylesheet (Tailwind + design tokens),
//   2. mounts the root component.

import { mount } from "svelte";
import App from "./App.svelte";
import "./app.css";

const target = document.getElementById("root");
if (!target) {
  // Should never happen — index.html ships the #root div. If it
  // does, we want to know loudly rather than render to <body>.
  throw new Error("hub-app: #root not found in index.html");
}

mount(App, { target });

// Dismiss the boot loader — but let its assembly choreography finish
// first. The animation (wordmark → slashes seating → glow → progress
// reveal) completes ~2.1s after the HTML parses; ripping the overlay
// out the instant the bundle is ready (a few hundred ms on a warm
// server) truncated it mid-flight. The app is already mounted
// underneath, so the hold costs no real readiness — only the overlay
// lingers, then fades via the .bl-done class (defined in index.html).
const loader = document.getElementById("boot-loader");
if (loader) {
  const FULL_CHOREOGRAPHY_MS = 2300;
  const FADE_MS = 480;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // performance.now() is time since navigation start — close enough
  // to when the loader's CSS animations began.
  const hold = reduced ? 0 : Math.max(0, FULL_CHOREOGRAPHY_MS - performance.now());
  window.setTimeout(() => {
    loader.classList.add("bl-done");
    window.setTimeout(() => loader.remove(), FADE_MS);
  }, hold);
}
